import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Main = styled.main`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 100%;
  `}
`;

export const Label = styled.main`
  ${({ theme }) => css`
    font-weight: 500;
    padding-top: 2.2rem;
    padding-bottom: 1rem;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.large};
    font-family: Roboto !important;
  `}
`;

export const Select = styled.div`
  ${({ theme }) => css`
    padding: 1rem;
    padding-top: 0;
    padding-bottom: 0;
    height: 39px;
    position: relative;
    border: 1px solid ${theme.colors.gray};
    border-radius: 5px;
    bottom: 2px;

    svg {
      position: absolute;
      right: 0;
      bottom: 4px;
    }
  `}
`;

export const InputSearch = styled.input`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    height: 3.3rem;
    border: none;
    margin-bottom: 0.5rem;

    padding-top: 0;
    font-size: ${theme.font.sizes.large};
    font-family: Roboto !important;

    ::placeholder {
      color: ${theme.colors.gray};
      font-style: italic;
      font-size: 1.4rem;
      font-family: Roboto !important;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-size: ${theme.font.sizes.small};
    margin-bottom: 0.3rem;
    font-weight: bold;
    letter-spacing: 0.3rem;
  `}
`;

export const Options = styled.div`
  ${({ theme }) => css`
    width: 100%;
    position: absolute;
    bottom: 0.3rem;
    border: 1px solid ${theme.colors.graySecondary};
    width: 100%;
    padding: 1rem 1.5rem 1rem;
    max-height: 10rem;
    overflow: auto;
    z-index: 9999999;
    background-color: ${theme.colors.white};
    margin-bottom: -70px !important;
  `}
`;

export const Option = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    padding: 0.5rem 0;
    cursor: pointer;

    &:last-child {
      border: none;
    }
  `}
`;
export const ArrowInput = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.lineBlue};
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: bold;
    font-size: ${theme.font.sizes.xsmall};
  `}
`;

export const Selected = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
